/* eslint-disable max-len */
import React, {ReactElement} from 'react';

const CCMIcon = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  stroke = 'currentColor',
  strokeWidth = 100,
  ...rest
}: React.SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width={width}
      height={height}
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
      fill="currentColor"
      stroke="currentColor"
      {...rest}>
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={fill}
        stroke={stroke}
        strokeWidth={strokeWidth}>
        <path d="M2615 4355 c-287 -63 -492 -291 -525 -585 -8 -74 -8 -97 4 -125 19 -44 54 -61 98 -49 44 12 68 61 68 135 0 162 114 339 266 413 226 111 466 55 629 -146 25 -32 57 -61 71 -64 35 -9 81 13 104 52 30 47 124 131 181 160 352 178 758 -102 724 -500 -29 -345 -274 -669 -701 -929 -107 -66 -268 -147 -289 -147 -21 0 -174 78 -286 146 -126 76 -257 176 -368 279 -92 86 -112 96 -154 73 -33 -17 -46 -39 -47 -78 0 -31 10 -45 87 -120 160 -155 353 -289 586 -406 100 -50 160 -74 183 -74 45 0 220 82 376 177 460 280 726 625 778 1011 33 240 -31 435 -194 597 -93 93 -201 152 -323 179 -200 44 -430 -14 -576 -144 l-57 -52 -63 51 c-162 134 -377 189 -572 146z" />
        <path d="M2780 3797 c-18 -9 -48 -60 -114 -194 l-90 -183 -262 0 c-262 0 -263 0 -290 -24 -39 -33 -39 -89 0 -122 l27 -24 302 0 c251 0 306 3 324 15 11 8 48 72 82 141 34 70 63 125 65 123 2 -2 70 -128 152 -279 82 -151 159 -285 171 -297 24 -25 62 -30 94 -13 10 6 64 78 119 160 l100 150 126 0 c125 0 126 0 155 29 17 18 29 40 29 56 0 16 -12 38 -29 56 l-29 29 -156 0 c-89 0 -165 -5 -179 -11 -13 -6 -54 -57 -91 -115 -38 -57 -72 -104 -76 -104 -5 0 -79 131 -166 291 -86 159 -168 299 -182 310 -29 22 -47 24 -82 6z" />
        <path d="M4355 2469 c-22 -5 -245 -114 -496 -242 l-457 -233 -5 40 c-10 76 -20 79 -244 82 -298 3 -496 39 -873 160 -505 161 -579 177 -742 156 -230 -29 -412 -126 -645 -344 -70 -65 -151 -127 -255 -194 -84 -53 -165 -109 -180 -123 -45 -41 -38 -72 45 -202 381 -596 494 -768 519 -792 23 -22 38 -28 62 -25 19 2 125 66 279 167 l247 163 728 -31 c400 -17 763 -32 807 -34 l80 -2 680 478 c374 263 697 496 717 518 100 109 88 300 -24 395 -66 55 -165 81 -243 63z m99 -173 c63 -26 86 -100 48 -158 -9 -16 -306 -231 -672 -488 -652 -458 -655 -460 -705 -460 -27 0 -356 14 -730 30 -374 16 -717 30 -761 30 l-82 0 -213 -142 c-118 -77 -221 -143 -229 -144 -13 -3 -110 143 -463 696 l-17 27 107 68 c135 85 166 109 281 217 159 151 269 221 422 270 62 19 96 23 195 22 120 0 121 -1 335 -69 644 -204 778 -234 1103 -250 75 -4 137 -11 137 -16 0 -24 -53 -109 -92 -149 -23 -23 -71 -56 -105 -72 -56 -27 -77 -30 -230 -40 -267 -16 -606 0 -796 38 -113 22 -157 1 -157 -76 0 -69 59 -90 335 -122 141 -16 671 -16 775 1 135 21 265 97 344 200 44 57 47 59 433 256 213 109 452 231 530 272 78 40 149 73 158 73 9 0 31 -6 49 -14z" />
      </g>
    </svg>
  );
};

export default CCMIcon;
